import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBranch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBranch"><Circle cx="6.5" cy="6" r="2.5" stroke="currentColor"/><Circle cx="6.5" cy="18" r="2.5" stroke="currentColor"/><Circle cx="17.5" cy="6" r="2.5" stroke="currentColor"/><Path d="M6.5 8.5V15.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M17.5 8.5V12H6.5V15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBranch;
